import { render } from "./PageBiayaKonfirmasi.vue?vue&type=template&id=38842798"
import script from "./PageBiayaKonfirmasi.vue?vue&type=script&lang=js"
export * from "./PageBiayaKonfirmasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__